import React from 'react';
import {
  ColumnContainer,
  Heading,
  LoginBackImage,
  LoginContainer,
  LoginWrapper,
  Logo,
  LogoWrap,
  PartialWrapLoginBackImage,
  Wrap,
} from 'pages/login/login_style';
import { useSelector } from 'react-redux';
import ResetPasswordComponent from 'component/login_components/resetPassword';

const ResetPassword = () => {
  const { defaultTheme } = useSelector((state) => state.themes);

  return (
    <div className='body-content'>
      {defaultTheme === 'globlue' ? (
        <LoginBackImage className='resetPassword-background-image'>
          <ColumnContainer className='globlue resetPassword-column-container'>
            <div className='column' />
            <div className='column'>
              <Wrap className='resetPassword-wrapper'>
                <LoginContainer className='resetPassword-container'>
                  <LogoWrap className='resetPassword-logo-wrap'>
                    <Logo alt='Logo' className='resetPassword-logo' />
                  </LogoWrap>
                  <Heading className={`${defaultTheme} resetPassword-heading`}>Reset Password</Heading>
                  <ResetPasswordComponent theme={defaultTheme} />
                </LoginContainer>
              </Wrap>
            </div>
          </ColumnContainer>
        </LoginBackImage>
      ) : defaultTheme === 'mornglow' ? (
        <PartialWrapLoginBackImage className='mornglow resetPassword-partial-wrapper'>
          <ColumnContainer className='mornglow resetPassword-column-container'>
            <div className='column'>
              <Wrap className='logoleft resetPassword-wrapper'>
                <Logo className='leftsideLogo resetPassword-logo' alt='Logo' />
                <LoginWrapper className={`${defaultTheme} resetPassword-inside-wrap`}>
                  <LoginContainer className='resetPassword-container'>
                    <Heading className={`${defaultTheme} resetPassword-heading`}>Reset Password</Heading>
                    <ResetPasswordComponent theme={defaultTheme} />
                  </LoginContainer>
                </LoginWrapper>
              </Wrap>
            </div>
          </ColumnContainer>
          <LoginBackImage className='resetPassword-background-image' />
        </PartialWrapLoginBackImage>
      ) : defaultTheme === 'nitrate' ? (
        <LoginBackImage className='resetPassword-background-image'>
          <ColumnContainer className='nitrate resetPassword-column-container'>
            <Wrap className='resetPassword-wrapper'>
              <LoginWrapper className={`${defaultTheme} resetPassword-inside-wrap`}>
                <LoginContainer className='resetPassword-container'>
                  <LogoWrap className='resetPassword-logo-wrap'>
                    <Logo alt='Logo' className='resetPassword-logo' />
                  </LogoWrap>
                  <Heading className={`${defaultTheme} resetPassword-heading`}>Reset Password</Heading>
                  <ResetPasswordComponent theme={defaultTheme} />
                </LoginContainer>
              </LoginWrapper>
            </Wrap>
          </ColumnContainer>
        </LoginBackImage>
      ) : defaultTheme === 'teamring' ? (
        <PartialWrapLoginBackImage className='resetPassword-partial-wrapper'>
          <LoginBackImage className='resetPassword-background-image'>
            <Wrap className='logoleft resetPassword-wrapper'>
              <Logo className='leftsideLogo resetPassword-logo' alt='Logo' />
            </Wrap>
          </LoginBackImage>
          <ColumnContainer className='teamring resetPassword-column-container'>
            <Wrap className='resetPassword-wrapper-second'>
              <LoginWrapper className={`${defaultTheme} resetPassword-inside-wrap`}>
                <LoginContainer className='resetPassword-container'>
                  <Heading className={`${defaultTheme} resetPassword-heading`}>Reset Password</Heading>
                  <ResetPasswordComponent theme={defaultTheme} />
                </LoginContainer>
              </LoginWrapper>
            </Wrap>
          </ColumnContainer>
        </PartialWrapLoginBackImage>
      ) : (
        ''
      )}
    </div>
  );
};

export default ResetPassword;
